<template>
  <v-layout>
    <v-btn @click="download()" class="text-none pb-2" flat><v-icon small class="mr-1"> description </v-icon>{{name}}</v-btn>
  </v-layout>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'BtnDownloadExcel',
  components: {},
  props: ['configExcel', 'data', 'balance', 'name'],
  methods: {
    open: function () {
    },
    onDownloadError: function (data) {
      Vue.prototype.$api.debug('onDownloadError', data)
      Vue.prototype.$api.hideIdle()
      swal(Vue.i18n.translate('DIALOG_TEXT_ERROR_DOWNLOAD_DOCUMENT'))
    },
    onDownloaded: function (data) {
      Vue.prototype.$api.debug('onDownloaded', data)
      Vue.prototype.$api.hideIdle()
    },
    createQuery () {
      var query = {}
      if (this.balance) {
        query.company = this.balance.crefoNr + ':' + this.balance.year + ':' + this.balance.aaNr + ':' + this.balance.rkNr + ':' + this.balance.source
      }
      return query
    },
    download: function (item) {
      Vue.prototype.$api.debug('download', item)
      Vue.prototype.$api.showIdle()
      this.configExcel.company = this.createQuery()
      Vue.prototype.$api.exportFileToExcel(this.configExcel, this.onDownloaded, this.onDownloadError)
    },
  },
  data () {
    return {
    }
  },
  mounted () {
    Vue.prototype.$api.checkCredentials(this)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/widgets/BtnDownloadExcel.vue